<div class="main-Content d-flex">
  <h3>Ticket Detail</h3>
  <div
    class="container-fluid d-flex flex-column mat-table elevation flex-1 px-5 py-5"
  >
    <div class="row">
      <div class="col-md-8 left-sec">
        <form #f="ngForm" novalidate>
          <div class="d-flex">
            <div class="col-sm-12">
              <div class="form-group row">
                <div class="col-sm-8">
                  <label>Products<span style="color: #ff232382">*</span></label>
                  <select
                    class="form-control"
                    [disabled]="true"
                    name="ProductId"
                    [(ngModel)]="ticket.ProductId"
                    #ProductId="ngModel"
                    (change)="onProductSelection()"
                    required
                  >
                    <option value="">Select Product</option>
                    <option
                      *ngFor="let product of products"
                      [value]="product.productID"
                    >
                      {{ product.productName }}
                    </option>
                  </select>
                  <label
                    class="text-danger"
                    *ngIf="
                      ProductId.invalid &&
                      submitted &&
                      ProductId.errors?.required
                    "
                    >Product is required.</label
                  >
                </div>
                <div class="col-sm-4">
                  <label>Created On </label>
                  <input
                    type="text"
                    placeholder="dd/mm/yyyy"
                    class="form-control"
                    name="startDateString"
                    [(ngModel)]="ticket.StartDateString"
                    disabled
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <label
                    >Problems<span style="color: #ff232382">*</span>
                  </label>
                  <select
                    class="form-control"
                    [(ngModel)]="ticket.ProblemId"
                    #ProblemId="ngModel"
                    [disabled]="true"
                    name="ProblemId"
                    (change)="onProblemSelection()"
                    required
                  >
                    <option value="">Select Problem</option>
                    <option
                      *ngFor="let problem of problems"
                      [value]="problem.problemID"
                    >
                      {{ problem.problemName }}
                    </option>
                  </select>
                  <label
                    class="text-danger"
                    *ngIf="
                      ProblemId.invalid &&
                      submitted &&
                      ProblemId.errors?.required
                    "
                    >Problem is required.</label
                  >
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-4">
                  <label>Impact<span style="color: #ff232382">*</span> </label>
                  <select
                    class="form-control"
                    [(ngModel)]="ticket.ImpactID"
                    #ImpactID="ngModel"
                    [disabled]="true"
                    name="ImpactID"
                    required
                  >
                    <option value="">Select Impact</option>
                    <option
                      *ngFor="let impact of impacts"
                      [value]="impact.impactID"
                    >
                      {{ impact.impactName }}
                    </option>
                  </select>
                  <label
                    class="text-danger"
                    *ngIf="
                      ImpactID.invalid && submitted && ImpactID.errors?.required
                    "
                    >Impact is required.</label
                  >
                </div>
                <div class="col-sm-4">
                  <label>Contact<span style="color: #ff232382">*</span> </label>
                  <input
                    type="text"
                    class="form-control"
                    [disabled]="true"
                    maxlength="10"
                    autocomplete="off"
                    placeholder="Mobile Number"
                    #contact="ngModel"
                    required
                    pattern="^((\\+91-?)|0)?[0-9]{10}$"
                    [(ngModel)]="ticket.Contact"
                    name="contact"
                    id="contact"
                  />
                  <label
                    class="text-danger"
                    *ngIf="
                      contact.invalid && submitted && contact.errors?.required
                    "
                    >Mobile number is required.</label
                  >
                  <span
                    class="text-danger"
                    *ngIf="contact.touched && contact.errors?.pattern"
                  >
                    Please enter 10 digit mobile number.
                  </span>
                </div>
                <div class="col-sm-4">
                  <label
                    >Email ID<span style="color: #ff232382">* </span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    [disabled]="true"
                    maxlength="200"
                    autocomplete="off"
                    placeholder="Email Address"
                    required
                    email
                    #email="ngModel"
                    [(ngModel)]="ticket.CC_EmailId"
                    name="email"
                    id="email"
                  />
                  <span
                    class="text-danger"
                    *ngIf="email.touched && email.errors?.email"
                  >
                    Enter a valid email address
                  </span>
                  <span
                    class="text-danger"
                    *ngIf="
                      (email.touched || submitted) && email.errors?.required
                    "
                  >
                    Email is required
                  </span>
                </div>

                &nbsp;
                <div class="col-sm-12">
                  <label>Description </label>
                  <textarea
                    class="form-control"
                    style="height: 110px !important"
                    [disabled]="true"
                    name="Problem Description"
                    [(ngModel)]="ticket.Description"
                  >
                  </textarea>
                </div>

                &nbsp;
                <div class="col-sm-12" *ngIf="ticket.LastReply != undefined">
                  <label>Last Reply </label>
                  <textarea
                    class="form-control"
                    style="margin-top: 0px; margin-bottom: 0px; height: 120px"
                    [disabled]="true"
                    name="LastReply"
                    [(ngModel)]="ticket.LastReply"
                  >
                  </textarea>
                </div>

                &nbsp;
                <div class="col-sm-12" *ngIf="!isCustomer">
                  <label>Reply</label>
                  <textarea
                    class="form-control"
                    style="margin-top: 0px; margin-bottom: 0px; height: 120px"
                    [disabled]="isCustomer"
                    #Reply="ngModel"
                    placeholder="Reply"
                    required
                    [(ngModel)]="ticket.Reply"
                    name="Reply"
                  >
                  </textarea>
                  <span
                    class="text-danger"
                    *ngIf="Reply.invalid && submitted && Reply.errors?.required"
                  >
                    Reply message is required
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-4 d-flex">
        <div class="d-flex upload-wrap">
          <div class="form-group row" style="margin-top: 0px !important">
            <div class="col-sm-12">
              <mat-form-field class="w-100" *ngIf="!isCustomer">
                <mat-label>Status </mat-label>
                <mat-select
                  [(ngModel)]="ticket.TicketStatusID"
                  name="TicketStatusID"
                  [disabled]="isCustomer"
                >
                  <mat-option
                    *ngFor="let status of statusList"
                    [value]="status.ticketStatusID"
                  >
                    {{ status.ticketStatusName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-12">
              <div class="text-left mx-auto" style="margin-top: 10px">
                <label class="text-left w-100"
                  >Assigned to : {{ ticket.AssingedTo }}</label
                >
              </div>
            </div>
            <div *ngIf="isCustomer" class="col-sm-12 d-flex">
              <mat-label>Ticket Status : </mat-label><br />
              <span
                *ngIf="ticket.TicketStatusID == 1"
                class="green-bg FontWeight500"
                >Open</span
              >
              <span
                *ngIf="ticket.TicketStatusID == 2"
                class="red-bg FontWeight500"
                >Pending</span
              >
              <span
                *ngIf="ticket.TicketStatusID == 3"
                class="orange-bg FontWeight500"
                >InProgress</span
              >
              <span
                *ngIf="ticket.TicketStatusID == 4"
                class="blue-bg FontWeight500"
                >Completed</span
              >
            </div>
            <br />
          </div>
          <div
            class="form-group row"
            *ngIf="!ticket.IsAssignedToMe && !isCustomer"
          >
            <div class="text-center mx-auto">
              <button
                type="button"
                *ngIf="!isassigningtome"
                (click)="AssignToMe()"
                class="btn btn-ok"
              >
                Assign to me
              </button>
              <span
                *ngIf="isassigningtome"
                class="spinner-border spinner-border-sm-2 mr-1"
              ></span>
            </div>
          </div>
          <div class="form-group row text-center mx-auto">
            <label class="w-100">Attached Files</label>
            <ul
              class="list-group"
              *ngFor="let file of attachedFiles"
              style="width: 336px; overflow: hidden"
            >
              <li class="list-group-item" style="cursor: pointer">
                <span (click)="DownloadFile(file.fileName)"
                  >{{ file.fileName }} &nbsp;
                  <i class="fa fa-download" aria-hidden="true"></i
                ></span>
              </li>
              &nbsp;
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- Edited here for Close button to display for all users -->
    <div class="text-center">
      <button
        type="button"
        *ngIf="!loading"
        (click)="onClose()"
        class="btn btn-close px-4 mt-3"
      >
        Close</button
      >&nbsp;&nbsp;&nbsp;
      <button
        type="button"
        *ngIf="!loading && !isCustomer"
        (click)="onSubmit(f.form.valid)"
        class="btn btn-ok px-4 mt-3"
      >
        Update Ticket
      </button>
      <span
        *ngIf="loading && submitted"
        style="margin-left: 15px !important"
        class="spinner-border spinner-border-sm-2 mr-1"
      ></span>
      &nbsp;
    </div>
  </div>
</div>
